var map = {
	"./alien.gif": 21356,
	"./bomb.gif": 99974,
	"./bowling.gif": 58860,
	"./cold_face.gif": 64604,
	"./cow_face.gif": 85355,
	"./cowboy_hat_face.gif": 99343,
	"./dog_face.gif": 76138,
	"./fire.gif": 16679,
	"./flying_saucer.gif": 54531,
	"./frog.gif": 9141,
	"./ghost.gif": 19242,
	"./hear_no_evil_monkey.gif": 8491,
	"./honeybee.gif": 76241,
	"./horse.gif": 54469,
	"./kangaroo.gif": 8785,
	"./oncoming_police_car.gif": 62575,
	"./owl.gif": 61925,
	"./penguin.gif": 30898,
	"./person_juggling.gif": 60777,
	"./pig_face.gif": 48206,
	"./pile_of_poo.gif": 52327,
	"./popcorn.gif": 88095,
	"./rabbit_face.gif": 77105,
	"./robot.gif": 2326,
	"./rocket.gif": 73577,
	"./roller_coaster.gif": 90419,
	"./sloth.gif": 1513,
	"./smiling_face_with_horns.gif": 39329,
	"./smiling_face_with_sunglasses.gif": 22203,
	"./snowman.gif": 23007,
	"./soccer_ball.gif": 33006,
	"./spouting_whale.gif": 99217,
	"./unicorn.gif": 71441,
	"./volcano.gif": 4125,
	"./zombie.gif": 62153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58756;